/**
 * Renders OpenSeadragon or OpenLayers for one map, as decided by viewerSelection.resolveViewer.
 * Both viewers take the same props, so the parent passes the map state through unchanged.
 */
import React from 'react';
import {connect} from 'react-redux';
import Slidemap from '../Slidemap';
import SlidemapOSD from './SlidemapOSD';
import {LoadingText} from '../components/components';
import {resolveViewer, VIEWERS} from './viewerSelection';
import AnnotationOverlayOSD from './annotations/AnnotationOverlayOSD';

const SlideMapWrapper = ({viewer, osdViewerConfig, dispatch, ...viewerProps}) => {
    if (!viewer) return <LoadingText color={"background.paper"}/>;
    if (viewer === VIEWERS.OL) return <Slidemap key="ol" {...viewerProps}/>;
    return (
        <div style={{position: 'relative', width: '100%', height: '100%', overflow: 'hidden', clipPath: 'inset(0)'}}>
            <SlidemapOSD key="osd" {...viewerProps} osdViewerConfig={osdViewerConfig}/>
            <AnnotationOverlayOSD mapId={viewerProps.id}/>
        </div>
    );
};

const mapStateToProps = (state, ownProps) => ({
    viewer: resolveViewer(state, ownProps),
    osdViewerConfig: state.osdViewerConfigReducer,
});

export default connect(mapStateToProps)(SlideMapWrapper);
